<template>
  <v-card style="border: 2px solid #ECEEF1" elevation="0" class="pa-0 ma-0  " width="100%">
    <v-dialog v-model="dialog" max-width="500">
      <Confirm
          title="Salvar"
          message="Tem certeza de que deseja atualizar as informações da vitrine?"
          buttonText="Salvar"
          @cancel="dialog = false"
          @action="submit"
      />
    </v-dialog>
    <v-tabs class="pa-0 ma-0" background-color="#ECEEF1" grow height="35" hide-slider>
      <v-tab
          active-class="active-tab"
          class="tab"
          id="tab0"
          style="font-weight: bold !important"
          href="#mobile-tabs-5-0"
          @click="activeTab = 0"
      >
        <span>Configuração da vitrine</span>
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="activeTab">
      <v-tab-item
          :value="0"
          class="pa-0 ma-0"

      >
        <v-form ref="form" :key="clear">
          <v-row class="" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <v-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6" class="">
              <div class="d-flex flex-column align-center justify-center">
                <p class="ma-0 mx-5 py-1 text-center">Imagem para dispositivos móveis (350px x 250x e tamanho máximo do arquivo 2mb).</p>
                <v-hover v-slot="{ hover }" v-if="currentUser.imageMobileShowcase != null">
                  <v-img
                      :src="currentUser.imageMobileShowcase"
                      style="
                            border-radius: 5px !important;
                            opacity: 0.7;
                            cursor: pointer;"
                      height="180"
                      width="300"
                      :class="hover ? 'elevation-5 mx-2' : 'mx-2'"
                  >
                    <v-expand-transition>
                      <div
                          v-if="hover"
                          class="d-flex flex-column justify-center align-center"
                          style="height: 100%; background: rgba(188, 0, 0, 0.6)"
                          @click="openPicker('imageInputMobile')"
                      >
                        <v-icon size="26" color="white">mdi-pen</v-icon>
                        <span class="edit-photo">Alterar foto</span>
                      </div>
                    </v-expand-transition>
                  </v-img>
                </v-hover>

                <span
                    class="delete-photo"
                    v-if="currentUser.imageMobileShowcase != null"
                    @click="(currentUser.imageMobileShowcase = null)"
                >
                        Excluir
                      </span>

                <div class="d-flex flex-column align-center" v-if="currentUser.imageMobileShowcase == null">
                  <v-hover>
                    <div class="image-container mx-2" @click="openPicker('imageInputMobile')">
                      <div class="d-flex flex-column align-center">
                        <v-img
                            src="/assets/add_photo.svg"
                            contain
                            max-width="46"
                        >
                        </v-img>
                        <span class="photo-field">Adicionar Foto</span>
                      </div>
                    </div>
                  </v-hover>
                </div>
              </div>

              <v-file-input
                  style="display: none"
                  id="imageInputMobile"
                  accept="image/png, image/jpeg, image/jpg"
                  :label="'Nenhuma imagem selecionada'"
                  filled
                  prepend-icon="mdi-camera"
                  @change="setImageMobile"
                  required
              ></v-file-input>
            </v-col>

            <v-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6" class="">
              <div class="d-flex flex-column align-center justify-center">
                <p class="ma-0 mx-4 py-1 text-center">Imagem para desktop (1920px x 700px e tamanho máximo do arquivo 2mb).</p>
                <v-hover v-slot="{ hover }" v-if="currentUser.imageDesktopShowcase != null">
                  <v-img
                      :src="currentUser.imageDesktopShowcase"
                      style="
                            border-radius: 5px !important;
                            opacity: 0.7;
                            cursor: pointer;"
                      height="180"
                      width="300"
                      :class="hover ? 'elevation-5 mx-2' : 'mx-2'"
                  >
                    <v-expand-transition>
                      <div
                          v-if="hover"
                          class="d-flex flex-column justify-center align-center"
                          style="height: 100%; background: rgba(188, 0, 0, 0.6)"
                          @click="openPicker('imageInputMobile')"
                      >
                        <v-icon size="26" color="white">mdi-pen</v-icon>
                        <span class="edit-photo">Alterar foto</span>
                      </div>
                    </v-expand-transition>
                  </v-img>
                </v-hover>

                <span
                    class="delete-photo"
                    v-if="currentUser.imageDesktopShowcase != null"
                    @click="(currentUser.imageDesktopShowcase = null)"
                >
                        Excluir
                      </span>

                <div
                    class="d-flex flex-column align-center"
                    v-if="currentUser.imageDesktopShowcase == null"
                >
                  <v-hover>
                    <div
                        class="image-container mx-2"
                        @click="openPicker('imageDesktop')"
                    >
                      <div class="d-flex flex-column align-center">
                        <v-img
                            src="/assets/add_photo.svg"
                            contain
                            max-width="46"
                        >
                        </v-img>
                        <span class="photo-field">Adicionar Foto</span>
                      </div>
                    </div>
                  </v-hover>
                </div>
              </div>

              <v-file-input
                  style="display: none"
                  id="imageDesktop"
                  accept="image/png, image/jpeg, image/jpg"
                  :label="'Nenhuma imagem selecionada'"
                  filled
                  prepend-icon="mdi-camera"
                  @change="setImageDesktop"
                  required
              ></v-file-input>
            </v-col>
          </v-row>
          <v-divider class="my-3 mx-4"></v-divider>
          <v-row cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="mx-2">
            <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
              <div>
                <label>Endereço</label>
                <v-textarea
                    class="mt-1"
                    dense
                    outlined
                    placeholder="Digite o endereço"
                    v-model="currentUser.addressShowcase"
                    :rules="[rules.required]"
                    rows="2"
                ></v-textarea>
              </div>
              <div>
                <label>Descrição</label>
                <v-textarea
                    class="mt-1"
                    dense
                    outlined
                    placeholder="Digite a descrição"
                    :rules="[rules.required]"
                    v-model="currentUser.descriptionShowcase"
                    rows="2"
                ></v-textarea>
              </div>
              <div>
                <label>Nome</label>
                <v-textarea
                    class="mt-1"
                    dense
                    outlined
                    :rules="[rules.required]"
                    placeholder="Digite o nome"
                    v-model="currentUser.nameShowcase"
                    rows="2"
                ></v-textarea>
              </div>
            </v-col>

            <v-col v-if="currentUser.urlStoreResale" cols="12" sm="12" md="12" lg="12">
              <span>Url da vitrine dos seus produtos </span><br/>
              <a target="_blank" :href="currentUser.urlStoreResale">
                <span class="label">{{ currentUser.urlStoreResale }}</span>
              </a>
              <v-btn
                  @click="copyUrl()"
                  class="ml-3 primary-button"
                  style="height: 35px!important; border-radius: 5px!important; width: fit-content!important;"
                  elevation="0"
              >
                Copiar url
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
        <v-row class="pb-3 mx-1">
          <v-divider class="my-3 mx-4"></v-divider>
          <v-col justify="end" cols="12" md="12">
            <v-btn
                width="300"
                class="primary-button float-right"
                color="normalred"
                elevation="0"
                @click="validate()"
            >
              Salvar configurações da vitrine
            </v-btn>
          </v-col>
        </v-row>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import ApiService from "../../../../services/ApiService";
import Vue from "vue";
import Confirm from "../../components/ConfirmExit.vue";

export default {
  name: "ShowcaseSettings",
  components: {Confirm},
  props: {},
  data: () => ({
    urlB2C: process.env.VUE_APP_BASE_URL_B2C,
    currentUser: {
      id: null,
      imageDesktopShowcase: null,
      imageMobileShowcase: null,
      addressShowcase: null,
      descriptionShowcase: null,
      nameShowcase: null,
      urlStoreResale: null,
    },
    apiService: new ApiService(),
    user: {},
    dialog: false,
    activeTab: 0,
    clear: 1,
    firstValid: null,
    userTypeMaster: 0,
    userTypeAdmin: 1,
    userTypeResale: 2,
    userTypeInstaller: 3,
    rules: {
      nameRules: (v) => (v && v.length <= 128) || "Nome deve ter no máximo 128 caracteres",
      required: (value) => !!value || "Campo requerido.",
      min: (v) => v.length >= 4 || "Minimo de 4 caracteres.",
    },
  }),
  async created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.urlB2C = process.env.VUE_APP_BASE_URL_B2C
    await this.getUser();
  },
  methods: {
    setImageDesktop(image) {
      if (image.size < 2097152) {
        const reader = new FileReader();
        reader.readAsDataURL(image);
        reader.onload = () => {
          this.currentUser.imageDesktopShowcase = reader.result;
        };
      } else {
        Vue.$globalEvent.$emit("onFlashMessage", {
          type: "warning",
          title: "",
          message: "Arquivo excede o limite de 2mb",
          trace: null,
        });
      }
    },

    setImageMobile(image) {
      if (image.size < 2097152) {
        const reader = new FileReader();
        reader.readAsDataURL(image);
        reader.onload = () => {
          this.currentUser.imageMobileShowcase = reader.result;
        };
      } else {
        Vue.$globalEvent.$emit("onFlashMessage", {
          type: "warning",
          title: "",
          message: "Arquivo excede o limite de 2mb",
          trace: null,
        });
      }
    },

    openPicker(idInput) {
      document.querySelector(`#${idInput}`).click();
    },
    async copyUrl() {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard
            .writeText(this.currentUser.urlStoreResale)
            .then(() => {
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "success",
                title: "",
                message: "Url copiada.",
                trace: null,
              });
            })
            .catch((err) => {
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "error",
                title: "",
                message: "Não foi possível copiar url",
                trace: null,
              });
            });
      }
    },

    async getUser() {
      this.loading = true;

      let url;

      switch (this.user.type) {
        case 0:
          url = "user/get-one";
          break;
        case 1:
          url = "user/get-one";
          break;
        case 2:
          url = "resale/get-one";
          break;
        case 3:
          url = "installer/get-one";
          break;
      }

      await this.apiService.get(`${url}?id=${this.user.id}`).then((response) => {
        this.currentUser = response;
        if (this.currentUser.urlStoreResale) {
          this.currentUser.urlStoreResale = `${this.urlB2C}/vitrine/${this.currentUser.urlStoreResale}`
        }
        this.loading = false;
      });
    },

    validate() {
      if (!this.currentUser.imageMobileShowcase) {
        Vue.$globalEvent.$emit("onFlashMessage", {
          type: "error",
          title: "",
          message: "Adicione a imagem para dispositivos moveis!",
          trace: null,
        });
        return;
      }
      if (!this.currentUser.imageDesktopShowcase) {
        Vue.$globalEvent.$emit("onFlashMessage", {
          type: "error",
          title: "",
          message: "Adicione a imagem para Imagem para desktop!",
          trace: null,
        });
        return;
      }
      if (!this.$refs.form.validate()) {
        Vue.$globalEvent.$emit("onFlashMessage", {
          type: "error",
          title: "Formulário não validado",
          message: "Confira o preenchimento",
          trace: null,
        });
        return
      }

      this.dialog = true;
    },

    async submit() {
      try {
        await this.apiService.put(`resale/edit/showcase/${this.currentUser.id}`, this.currentUser)
            .then((resp) => {
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "success",
                title: resp.message,
                message: resp.message,
                trace: null,
              });

              this.dialog = false;
              this.loading = false;
            })
            .catch((err) => {
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "error",
                title: "Erro ao cadastrar produto",
                message: err.body.message,
                trace: null,
              });

              this.dialog = false;
              this.loading = false;
            });
        await this.getUser();
      } catch (e) {

      }
    },
  },
};
</script>
<style scoped>
::placeholder {
  color: blue !important;
  font-size: 1.5em !important;
}

.delete-photo {
  cursor: pointer;
  font-weight: normal;
  font-size: 18px;
  line-height: 27px;
  letter-spacing: 0.15px;
  color: #bc0000;
}

.edit-photo {
  font-weight: 600;
  font-size: 18px;
  line-height: 27px;
  letter-spacing: 0.15px;
  color: #ffffff;
}

.photo-field {
  font-weight: 600;
  font-size: 18px;
  line-height: 27px;
  /* identical to box height */

  letter-spacing: 0.15px;

  color: #9c9c9c;
}

.image-container {

  display: flex;
  justify-content: center;
  align-items: center;
  width: 300px !important;
  height: 180px;
  background: #dadada;
  cursor: pointer;
  transition: 0.1s;
  box-sizing: border-box;
  border-radius: 5px !important;
}

@media (max-width: 600px) {
  .image-container {
    width: 200%;
  }
}

@media (max-width: 900px) {
  .image-container {
    width: 200%;
  }
}

@media (max-width: 300px) {
  .image-container {
    width: 145%;
  }
}

.cancel-button {
  border-radius: 7.5px !important;
  transition: 0.3s !important;
}

.cancel-button:hover {
  color: white !important;
  background: #000000 !important;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2) !important;
}

.date-input {
  background: #f5f5f5;
  text-align: center !important;
  border: 1px solid #979797;
  box-sizing: border-box;
  border-radius: 8px;
  border-right-style: inset !important;
}

.date-title {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 25px;
  line-height: 29px;
  letter-spacing: 0.15px;

  color: #232021;
}

.title-g {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 40px;

  color: #000000;
}

.texto-p {
  font-family: Roboto;
  font-style: normal;
  font-weight: 300;
  font-size: 13px;
  line-height: 35px;
  color: #9c9c9c;
}

.active-tab {
  background: #2d3038;
  color: #ffffff !important;
}
</style>
